import type {PinDetailsData} from '../../types';

import {numberFormat} from 'utils/Helper';

import PackageMetricCard from './components/PackageMetricCard/PackageMetricCard';

type PackageSummaryProps = {
  statistics?: NonNullable<PinDetailsData['pin']>['statistics'];
};

const PackageSummary: React.FC<PackageSummaryProps> = ({statistics}) => {
  return (
    <section className="flex flex-col gap-2.5 p-2.5">
      <h2 className="text-subtitle-md text-neutral-fg">گزارش عملکرد بسته</h2>
      <div className="flex gap-2.5">
        <PackageMetricCard title="نمایش در لیست" value={statistics?.number_of_views ?? 0} />
        <PackageMetricCard title="بازدید از فروشگاه" value={statistics?.number_of_clicks ?? 0} />
      </div>
      <div className="flex gap-2.5">
        <PackageMetricCard
          title="سفارش‌های روز"
          value={numberFormat(statistics?.order_count ?? 0)}
        />
        <PackageMetricCard
          title="فروش روز"
          value={`${numberFormat(statistics?.polygon_demand ?? 0)} تومان`}
        />
      </div>
    </section>
  );
};

export default PackageSummary;
